import { BaseModel } from './base.model';
import { ImageModel } from './image.model';

export class FileModel extends BaseModel {
  id: number;
  imageId: number;
  mimeType: string;
  storageType: string;
  storageKey: string;
  size: number;

  image: ImageModel;

  get childModels(): {} {
    return {
      image: ImageModel,
    };
  }

  getImageUrl(): string | undefined {
    return this.image?.originalUrl;
  }
}
